import styled from "styled-components";
import {
    ItemMenuChoixOnPage,
    MbjButton, MbjErrorData, MbjFlex,
    MbjLoading, MbjMenuChoixOnPage,
    MbjModal,
    MbjNavPath,
    MbjNoResult,
    MbjWidgetClassic,
    useModal
} from "@mbj-front-monorepo/ui";
import {useLocation, useParams} from "react-router-dom";
import {useGetFiPart, useGetParticulier, useGetXpPart} from "@mbj-front-monorepo/data-access";
import {GoPlus} from "react-icons/go";
import {
    MbjParticulierFiCard,
    MbjParticulierFiNewForm,
    MbjParticulierXpCard,
    MbjParticulierXpNewForm
} from "@mbj-front-monorepo/data-ui";
import * as React from "react";
import {useState} from "react";
import {BsDownload} from "react-icons/bs";

interface CvOneCvThequeCtrlProps{
    className?:string;
}

const Menus:ItemMenuChoixOnPage[] = [
    {id:0, libelle:'Expériences professionnelles'},
    {id:1, libelle:'Formations Initiales'},
]

const CvOneCvThequeCtrl = (props:CvOneCvThequeCtrlProps)=>{
    const { isShowing: isShowingAddXp, toggle: toggleAddXp } = useModal();
    const { isShowing: isShowingAddFi, toggle: toggleAddFi } = useModal();
    const { id } = useParams();
    const particulierQuery = useGetParticulier(parseInt(id || "-1"));
    const xpQuery = useGetXpPart(id ? parseInt(id) : undefined);
    const FisQuery = useGetFiPart(id ? parseInt(id) : undefined);
    const [MenuCurrent, setMenuCurrent] = useState<ItemMenuChoixOnPage>({id:0, libelle:'Expériences professionnelles'})
    const DownloadCV = ()=>{
        window.open(`${process.env["REACT_APP_API_URL_ROOT"]}/documents/${particulierQuery.data?.CvDocument}`)
    }
    return (
        <div className={"cv_cv_theque " + props.className}>

            {xpQuery.isLoading || FisQuery.isLoading || particulierQuery.isLoading ? (
                <MbjLoading />
            ) : xpQuery.isError || FisQuery.isError || particulierQuery.isError ? (
                <MbjErrorData/>
            ) : (
                <div className={`wrap_page_cv`}>

                    <MbjMenuChoixOnPage current={MenuCurrent} setChoix={setMenuCurrent} Items={Menus}/>
                    <div className={`content_cv`}>
                        {MenuCurrent.id === 0 ?
                            <MbjWidgetClassic justify={"center"} bodyDirection={"column"}>
                                <MbjFlex justify={"flex-end"}>
                                    <MbjButton  leftIcon={<GoPlus />} onClick={toggleAddXp} alignSelf={"flex-end"}  themeColor={"third"}>
                                        Ajouter une expérience
                                    </MbjButton>
                                    {particulierQuery.data?.CvDocument &&
                                        <MbjButton leftIcon={<BsDownload/>} themeColor={"primary"} onClick={DownloadCV}>Télécharger le cv</MbjButton>
                                    }
                                </MbjFlex>
                                {xpQuery.data && xpQuery.data.length > 0 ? (
                                    xpQuery.data?.map((xp, index) => <MbjParticulierXpCard ParticulierXp={xp} key={xp.id} />)
                                ) : (
                                    <MbjNoResult text={"Aucune expérience trouvée"} />
                                )}
                                <MbjModal
                                    isShowing={isShowingAddXp}
                                    hide={toggleAddXp}
                                    fitContent
                                    title="Nouvelle expérience professionnelle"
                                >
                                    <MbjParticulierXpNewForm idParticulier={particulierQuery.data?.id || -1} hideModal={toggleAddXp} />
                                </MbjModal>
                            </MbjWidgetClassic>:
                            <MbjWidgetClassic bodyDirection={"column"}>
                                <MbjFlex justify={"flex-end"}>
                                    <MbjButton leftIcon={<GoPlus />} onClick={toggleAddFi} alignSelf={"flex-end"} themeColor={"third"}>
                                        Ajouter une formation
                                    </MbjButton>
                                    {particulierQuery.data?.CvDocument &&
                                        <MbjButton leftIcon={<BsDownload/>} themeColor={"primary"} onClick={DownloadCV}>Télécharger le cv</MbjButton>
                                    }
                                </MbjFlex>

                                {FisQuery.data && FisQuery.data.length > 0 ? (
                                    FisQuery.data?.map((fi, index) => <MbjParticulierFiCard ParticulierFi={fi} key={fi.id} />)
                                ) : (
                                    <MbjNoResult text={"Aucune formations initiales trouvés"} />
                                )}
                                <MbjModal isShowing={isShowingAddFi} hide={toggleAddFi} fitContent title="Nouvelle formation initiale">
                                    <MbjParticulierFiNewForm idParticulier={particulierQuery.data?.id || -1} hideModal={toggleAddFi} />
                                </MbjModal>
                            </MbjWidgetClassic>
                        }
                    </div>
                </div>
            )}
        </div>
    )
}

export const CvOneCvTheque = styled(CvOneCvThequeCtrl)`
    padding: 1%;
    height: 100%;
    .wrap_page_cv{
      display: flex;
      flex-direction: column;
      height: 100%;
      .content_cv{
        flex-grow: 1;
        overflow-y: auto;
        padding: 10px;
      }
    }
`
